import { SalesItemModel } from "@/apidtos";
import { useApi } from "@core/api";
import { registerExtension } from "@core/components/PipelineComponents/ExtensionProvider";
import { Badge } from "@core/components/ui/badge";
import { LoadingOverlay } from "@core/components/ui/loading-overlay";
import { TableCell, TableHead } from "@core/components/ui/table";
import { Link } from "@remix-run/react";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

interface IMedCheckoutMiniCartExtensionProps {
  salesItem: SalesItemModel;
}
const MedCheckoutMiniCartExtension = ({ salesItem }: IMedCheckoutMiniCartExtensionProps) => {
  const api = useApi();
  const { t } = useTranslation();

  const patientQuery = useQuery({
    queryKey: ["patient", "salesItem", salesItem.Id],
    queryFn: async () => {
      return await api.GetProviderPrescriptionSalesItemBySalesItemId(salesItem.Id)
    },
  })
  if (patientQuery.isLoading) {
    return null;
  }
  if (patientQuery.isError || !patientQuery.data) {
    return null;
  }

  const type = salesItem.Tags?.find((tag) => tag.Key === "ShippingOption")?.Value;

  return (
    <div className="flex flex-row flex-wrap gap-2 text-sm">
      {/* <Link className="text-[var(--link-color)]"
        to={`/dashboard/patient/${patientQuery.data.PrescriptionPatientId}`}>
        {patientQuery.data.PrescriptionPatientName}
      </Link> */}
      <Badge className="bg-info-500 hover:bg-info-600">{type}</Badge>
      <Badge className="bg-info-500 hover:bg-info-600">{patientQuery.data.PrescriptionPatientName}</Badge>
      {patientQuery.data.PatientPay && (
        <Badge className="bg-info-500 hover:bg-info-600">
          {t("ui.med.patient.pay", "Patient Pay")}
        </Badge>
      )}
    </div>
  );
};

registerExtension("_site.checkout.route.minicart.aftername", MedCheckoutMiniCartExtension);
